import { useMemo } from 'react'
import _ from 'lodash'

const useLifeExpectancy = (person, allSpendingBaseCases, allSpendingModifiedCases) => {
  return useMemo(() => {
    const primaryBaseYear = _.get(
      allSpendingBaseCases,
      'averageMarketSpendingAdvice.primary.lifeExpectancyYear',
      0
    )
    const spouseBaseYear = _.get(
      allSpendingBaseCases,
      'averageMarketSpendingAdvice.spouse.lifeExpectancyYear',
      0
    )
    const primaryBaseAge = _.get(
      allSpendingBaseCases,
      'averageMarketSpendingAdvice.primary.lifeExpectancyAge',
      0
    )
    const spouseBaseAge = _.get(
      allSpendingBaseCases,
      'averageMarketSpendingAdvice.spouse.lifeExpectancyAge',
      0
    )

    const primaryModifiedYear = _.get(
      allSpendingModifiedCases,
      'averageMarketSpendingAdvice.primary.lifeExpectancyYear',
      0
    )
    const spouseModifiedYear = _.get(
      allSpendingModifiedCases,
      'averageMarketSpendingAdvice.spouse.lifeExpectancyYear',
      0
    )
    const primaryModifiedAge = _.get(
      allSpendingModifiedCases,
      'averageMarketSpendingAdvice.primary.lifeExpectancyAge',
      0
    )
    const spouseModifiedAge = _.get(
      allSpendingModifiedCases,
      'averageMarketSpendingAdvice.spouse.lifeExpectancyAge',
      0
    )

    const primaryHasLongerOrEqualYear = primaryBaseYear >= spouseBaseYear

    const primaryLifeExpectancyAge = person.includeSpouse
      ? primaryHasLongerOrEqualYear
        ? primaryModifiedAge + 10
        : primaryBaseAge
      : primaryModifiedAge + 10

    const primaryLifeExpectancyYear = person.includeSpouse
      ? primaryHasLongerOrEqualYear
        ? primaryModifiedYear + 10
        : primaryBaseYear
      : primaryModifiedYear + 10

    const spouseLifeExpectancyAge = !primaryHasLongerOrEqualYear
      ? spouseModifiedAge + 10
      : spouseBaseAge

    const spouseLifeExpectancyYear = !primaryHasLongerOrEqualYear
      ? spouseModifiedYear + 10
      : spouseBaseYear

    return {
      primaryLifeExpectancyAge,
      spouseLifeExpectancyAge,
      primaryLifeExpectancyYear,
      spouseLifeExpectancyYear,
    }
  }, [person.includeSpouse, allSpendingBaseCases, allSpendingModifiedCases])
}

export default useLifeExpectancy
